(function (global) {
  function toNumber(value, fallback) {
    const parsed = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(parsed) ? parsed : (fallback !== undefined ? fallback : 0);
  }

  function clamp(value, min, max) {
    const n = toNumber(value, min);
    return Math.min(Math.max(n, min), max);
  }

  function sanitizeNumericInput(input, opts) {
    const options = opts || {};
    const allowNegative = Boolean(options.allowNegative);
    const source = String(input || '');
    let cleaned = source.replace(/[^0-9.-]/g, '');

    // Keep only the first decimal point.
    const firstDot = cleaned.indexOf('.');
    if (firstDot !== -1) {
      cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
    }

    // Keep only a leading minus sign when negatives are allowed.
    cleaned = cleaned.replace(/-/g, '');
    if (allowNegative && source.trim().startsWith('-')) {
      cleaned = '-' + cleaned;
    }

    return cleaned;
  }

  function parseNumericInput(input, fallback, opts) {
    const sanitized = sanitizeNumericInput(input, opts);
    if (!sanitized || sanitized === '-' || sanitized === '.') {
      return fallback !== undefined ? fallback : 0;
    }

    const parsed = parseFloat(sanitized);
    return Number.isFinite(parsed) ? parsed : (fallback !== undefined ? fallback : 0);
  }

  function parseCurrencyInput(input, fallback, opts) {
    return parseNumericInput(input, fallback, opts);
  }

  function formatCurrency(value, opts) {
    const options = opts || {};
    const empty = options.empty !== undefined ? options.empty : '';
    if (value === null || value === undefined || value === '') return empty;

    const parsed = toNumber(value, NaN);
    if (!Number.isFinite(parsed)) return empty;

    return parsed.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: options.minimumFractionDigits !== undefined ? options.minimumFractionDigits : 0,
      maximumFractionDigits: options.maximumFractionDigits !== undefined ? options.maximumFractionDigits : 0
    });
  }

  function formatNumber(value, opts) {
    const options = opts || {};
    const parsed = toNumber(value, NaN);
    if (!Number.isFinite(parsed)) return options.empty !== undefined ? options.empty : '';

    if (options.currency) {
      return formatCurrency(parsed, options);
    }

    return parsed.toLocaleString('en-US', {
      minimumFractionDigits: options.minimumFractionDigits !== undefined ? options.minimumFractionDigits : 0,
      maximumFractionDigits: options.maximumFractionDigits !== undefined ? options.maximumFractionDigits : 0
    });
  }

  function applyDisplayCurrency(vm, field, opts) {
    const options = opts || {};
    const displayField = field + 'Display';
    const parsed = parseCurrencyInput(vm[displayField], 0, options);
    vm[field] = parsed;
    vm[displayField] = formatCurrency(parsed, {
      minimumFractionDigits: options.minimumFractionDigits,
      maximumFractionDigits: options.maximumFractionDigits,
      empty: options.empty
    });
    return parsed;
  }

  global.NumberUtils = {
    toNumber: toNumber,
    clamp: clamp,
    sanitizeNumericInput: sanitizeNumericInput,
    parseNumericInput: parseNumericInput,
    parseCurrencyInput: parseCurrencyInput,
    formatCurrency: formatCurrency,
    formatNumber: formatNumber,
    applyDisplayCurrency: applyDisplayCurrency
  };
})(window);
